import React from 'react';
import {
	useSequencesContext,
	type TabsOptionsType
} from '../../SequencesContext';

export default function StepsContainerNav() {
	const { selectedSequence } = useSequencesContext();

	return (
		<div className="flex h-full w-full text-xl">
			<TabButton tabOption="SEQUENCE">
				{selectedSequence?.name || 'Preview'}
			</TabButton>
			<TabButton tabOption="BUSINESSES">Businesses</TabButton>
		</div>
	);
}

function TabButton({
	children,
	tabOption
}: {
	children: React.ReactNode;
	tabOption: TabsOptionsType;
}) {
	const { activeTab, setActiveTab, selectedSequence } = useSequencesContext();

	const handleClick = () => {
		setActiveTab(tabOption);
	};

	const isSelected = tabOption === activeTab;

	return (
		<button
			disabled={!selectedSequence}
			onClick={handleClick}
			className={`relative w-full ${isSelected && 'text-orange'}`}
		>
			{children}
			{isSelected && (
				<div className="absolute bottom-0 left-0 right-0 mx-auto h-1 w-11/12 rounded-md bg-orange" />
			)}
		</button>
	);
}
